import EditableContent from './EditableContent';
import withProps from 'recompose/withProps';
import isEmpty from 'lodash/isEmpty';
import { GIFTWRAP_ADDON_TYPES, EXTRA_ADDON_TYPES } from 'src/common/utils/addons';

const getAddonsOfType = (addons, types) => {
  if ((!addons || isEmpty(addons)) && (!types || isEmpty(types))) {
    return [];
  }
  return addons.filter(addon => types.some(type => addon.id.includes(type)));
};

const enhance = withProps(props => {
  const giftwrapAddons = getAddonsOfType(props.addons, GIFTWRAP_ADDON_TYPES);
  const extraAddons = getAddonsOfType(props.addons, EXTRA_ADDON_TYPES);
  return {
    giftwrapAddons,
    extraAddons,
  };
});

export default enhance(EditableContent);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/LineItem/EditableContent/index.js